<div class="d-flex flex-column g-space-sm">
  <div class="element">
    <div class="label mb-space-sm">
      <div>
        {{ 'core.date-time-range-editor.date' | translate }}
      </div>
    </div>
    <div class="align-center">
      <cam-edit-field
        [isLoading]="this.editRequestState().isLoading()"
        [getInput]="this.getFields(this.EDateTimeEditorFields.date)"
        (newValue)="this.emit($event, this.EDateTimeEditorFields.date)"
      >
        <div class="value">
          {{ this.startDate() | camDate: 'shortDate' }}
        </div>
      </cam-edit-field>
    </div>
  </div>
  <div class="row">
    <div class="element col-6">
      <div class="label mb-space-sm">
        {{ 'core.date-time-range-editor.startDate' | translate }}
      </div>
      <div class="align-center">
        <cam-edit-field
          [isLoading]="this.editRequestState().isLoading()"
          [getInput]="this.getFields(this.EDateTimeEditorFields.start)"
          (newValue)="this.emit($event, this.EDateTimeEditorFields.start)"
        >
          <div class="value">
            {{ this.startDate() | camDate: 'shortTime' }}
          </div>
        </cam-edit-field>
      </div>
    </div>
    <div class="element col-6">
      <div class="label mb-space-sm">
        {{ 'core.date-time-range-editor.endDate' | translate }}
      </div>
      <div class="align-center">
        <cam-edit-field
          [isLoading]="this.editRequestState().isLoading()"
          [getInput]="this.getFields(this.EDateTimeEditorFields.end)"
          (newValue)="this.emit($event, this.EDateTimeEditorFields.end)"
        >
          <div class="value">
            {{ this.endDate() | camDate: 'shortTime' }}
          </div>
        </cam-edit-field>
      </div>
    </div>
  </div>
</div>
